import { URLPattern as URLPatternPolyfill } from "urlpattern-polyfill";

if (typeof globalThis.URLPattern === "undefined") {
	// @ts-expect-error - URLPattern is not defined in the global scope
	globalThis.URLPattern = URLPatternPolyfill;
}
